export const upperFirst = (title: string): string => {
  return title.charAt(0).toUpperCase() + title.slice(1)
}

// used to throw an effective error if env var is missing
export const fetchEnvironmentVar = (name: string): string => {
  const value = process.env[name]
  if (!value) {
    throw new Error(`Required environment variable ${name} is not set`)
  }
  return value
}
